import api from '@/api'
import presetsStorage from '@/storage/presets'

export default {
  namespaced: true,
  state: {
    presets: [],
    total: 0
  },
  actions: {
    async fetchPresets ({ commit }) {
      const presetsAPI = await api.getPresets()
      const modulesInstalled = await this.getters['module/definitionModulesInstalled']

      const presetsDefault = presetsStorage.filter(
        presetDefault => modulesInstalled.find(
          moduleInstalled => presetDefault.to.identifier === moduleInstalled.identifier && presetDefault.to.type === moduleInstalled.type
        )
      )

      var presets = []

      for (let i in presetsDefault) {
        let preset = presetsDefault[i]

        const presetAPI = presetsAPI.filter(
          presetAPI => (
            preset.from.type === presetAPI.from.type && preset.from.identifier === presetAPI.from.identifier &&
            preset.to.type === presetAPI.to.type && preset.to.identifier === presetAPI.to.identifier &&
            preset.type === presetAPI.type
          )
        )

        if (presetAPI.length === 1) {
          if (presetAPI[0].items) {
            preset.items = presetAPI[0].items
          }
          preset.active = presetAPI[0].active
          preset.isCreated = true
        }

        preset.from = await this.getters['module/getDefinitionModuleByIdentifierAndType'](preset.from.type, preset.from.identifier)
        preset.to = await this.getters['module/getDefinitionModuleByIdentifierAndType'](preset.to.type, preset.to.identifier)

        if (preset.from.module !== null && preset.to.module !== null) {
          presets.push(preset)
        }
      }

      presets = presets.sort(function (a, b) {
        if (a.active < b.active) {
          return 1
        }

        if (a.active > b.active) {
          return -1
        }

        return 0
      })

      commit('setPresets', presets)
    }
  },
  getters: {
    getPresetByFromToAndType: state => (from, to, type) => state.presets.find(preset => (
      preset.from.type === from.type && preset.from.identifier === from.identifier &&
      preset.to.type === to.type && preset.to.identifier === to.identifier &&
      preset.type === type
    )),
    getPresetItemsByFromAndTo: state => (from, to, type) => state.presets.filter(preset => (
      preset.from.type === from.type && preset.from.identifier === from.identifier &&
      preset.to.type === to.type && preset.to.identifier === to.identifier
    )).map(preset => ({
      type: preset.type,
      items: preset.items
    }))
  },
  mutations: {
    setPresets (state, presets) {
      state.total = presets.length
      state.presets = [...presets]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/presets.js